import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { COMPANY } from "@/lib/data";

const POINTS = [
  "Locally owned & operated in St. Louis",
  "Hand-picked, well-maintained vehicles",
  "Same-day pickup and free metro delivery",
  "Honest, upfront pricing — every time",
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 border-t border-white/5 bg-[#080808]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-white/10 bg-black flex items-center justify-center p-10">
            <img src={COMPANY.logo} alt="Auto-Hire STL" className="w-full h-full object-contain" />
          </div>
          <div className="absolute -bottom-6 -right-2 md:right-6 bg-[#F2B705] text-black rounded-xl px-6 py-4 shadow-xl">
            <div className="font-display font-black text-3xl">2025</div>
            <div className="text-xs uppercase tracking-widest font-semibold">Est. in the Lou</div>
          </div>
        </motion.div>

        <div>
          <span className="text-xs md:text-sm tracking-[0.25em] uppercase text-[#F2B705] font-bold">Our Story</span>
          <h2 className="font-display font-black tracking-tighter text-4xl md:text-5xl mt-3 leading-[0.95]">
            More Than A Rental.<br /><span className="text-gold-gradient">Ride With Us.</span>
          </h2>
          <p className="text-white/60 mt-5 text-lg font-light leading-relaxed">
            Auto-Hire STL was born in the heart of St. Louis with one mission: make renting a car
            feel effortless and fair. No counters, no upsells, no fine print — just clean rides
            and real people who treat you like a neighbor.
          </p>
          <p className="text-white/50 mt-4 font-light leading-relaxed">
            Whether you're visiting the Arch, heading to the airport, or need wheels for the month,
            we deliver the right vehicle to your door at a price you can trust.
          </p>

          <ul className="mt-8 space-y-4">
            {POINTS.map((p, i) => (
              <motion.li
                key={p}
                data-testid={`about-point-${i}`}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="flex items-center gap-3"
              >
                <span className="w-6 h-6 rounded-full bg-[#F2B705] flex items-center justify-center shrink-0">
                  <Check size={14} className="text-black" />
                </span>
                <span className="text-white/80">{p}</span>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
